import { Model, Attr } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'

@Model()
export default class Country extends ApplicationRecord {
  static jsonapiType = 'countries'

  @Attr() id!: string
  @Attr() name!: string
  @Attr() code!: string
}
